import { createSelector } from "reselect";
const selector = (state) => state.wellness;

export default createSelector([selector], (data) => data);
